import {
  Box,
  Button,
  Heading,
  Image,
  StackProps,
  Text,
  VStack
} from "@chakra-ui/react";

interface EmptyStateProps extends StackProps {
  title?: string;
  description?: string;
  ctaText?: string;
  ctaAction?: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title = "Start using Jack now",
  description,
  ctaText,
  ctaAction = () => {},
  ...rest
}) => (
  <VStack {...rest} w="full" justify="center">
    <Heading color="secondary.600" fontSize={24} fontWeight={600}>
      {title}
    </Heading>

    <Text color="secondary.600" fontSize={14}>
      {description}
    </Text>

    {ctaText && (
      <Button onClick={ctaAction} h={12} fontSize={15} minW={167} mt={38}>
        {ctaText}
      </Button>
    )}

    <Box mt={38}>
      <Image src="/images/stack.svg" alt="empty state" />
    </Box>
  </VStack>
);
